import React from 'react'
import { Icon, IconProps } from '../components/Icon'
const SvgAppleLogo: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.41 12.058c-.026-2.865 2.346-4.258 2.454-4.323-1.343-1.959-3.425-2.226-4.156-2.247-1.749-.184-3.445 1.046-4.335 1.046-.909 0-2.28-1.029-3.759-.998-1.902.029-3.681 1.13-4.657 2.84-2.015 3.488-.512 8.612 1.417 11.43.966 1.381 2.094 2.922 3.57 2.868 1.445-.06 1.984-.92 3.727-.92 1.727 0 2.234.92 3.74.886 1.55-.025 2.526-1.387 3.458-2.78 1.115-1.582 1.563-3.14 1.58-3.22-.036-.013-3.01-1.148-3.04-4.582zM12.565 3.635c.777-.972 1.308-2.294 1.16-3.635-1.124.05-2.53.778-3.34 1.728-.716.837-1.356 2.21-1.19 3.5 1.262.095 2.56-.637 3.37-1.593z"
        fill="#fff"
      />
    </Icon>
  )
}
export default SvgAppleLogo
